<template>
    <div class="courses-single-page bg-dark-blue">
        <div class="fixed-wrapper">
            <button class="btn-template btn-delete-user" v-on:click="toggleDeleteModal" v-if="userRole === 'admin' && user && user.id !== 0">DELETE</button>
            <button class="btn-template btn-save" v-on:click="save">
                {{user && user.id === 0 ? "CREATE" : "SAVE"}}
            </button>
        </div>
        <div v-if="savedMessage" class="save-toast">{{ savedMessage }}</div>
        <div class="container">
            <div v-if="user" class="row">
                <div class="col-lg-12">
                    <div class="content-page-wrap clearfix">
                        <div class="card mt-3 mb-3">
                            <div class="container-fluid pl-0 pr-0">

                                <div class="course-single tab-content" style="padding-top: 30px; padding-bottom: 30px;">
                                    <div class="container-fluid">
                                        <div class="d-flex justify-content-between mb-3">
                                            <div class="title">
                                                {{user.id === 0 ? "Create a new user" : "Edit user details"}}

                                            </div>
                                        </div>
                                    </div>
                                    <div class="container-fluid d-flex" v-bind:class="{end : userRole == 'author', between : userRole == 'admin'}">
                                        <div class="site-select" v-if="userRole == 'admin'">
                                            <select v-model="selectedSite">
                                                <option v-for="site in sites" :value="site">{{site.name}}</option>
                                            </select>
                                        </div>

                                    </div>
                                    <div class="d-flex">
                                        <div class="container-fluid">
                                            <label>Name</label>
                                            <input type="text" placeholder="Enter name..." v-model="user.firstName" />
                                        </div>
                                        <div class="container-fluid">
                                            <label>Surname</label>
                                            <input type="text" placeholder="Enter surname..." v-model="user.lastName" />
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div class="container-fluid w-50">
                                            <label>Email</label>
                                            <input type="text" placeholder="Enter email..." v-model="user.email" />
                                        </div>
                                        <div class="container-fluid w-50">
                                            <label>Password</label>
                                            <input type="text" placeholder="Enter password..." v-model="user.newPassword" />
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div class="container-fluid">
                                            <label>Qualification</label>
                                            <input type="text" placeholder="Enter qualification..." v-model="user.qualification" />
                                        </div>
                                        <div class="container-fluid">
                                            <label>Job title</label>
                                            <input type="text" placeholder="Enter job title..." v-model="user.jobTitle" />
                                        </div>
                                    </div>
                                    <div class="d-flex">
                                        <div class="container-fluid" v-if="siteHasProperty('IdNumber') && userRole == 'admin'">
                                            <label>ID Number</label>
                                            <input type="text" placeholder="Enter ID number..." v-model="user.idNumber" />
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex">
                                        <div class="container-fluid" v-if="user && getSite(user.siteId) && getSite(user.siteId).divisions && getSite(user.siteId).divisions.length">
                                            <label>Division</label>

                                            <select v-model="user.division">
                                                <option v-for="division in getSite(user.siteId).divisions" :value="division">
                                                    {{ division }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                                                        

                                    <div class="container-fluid roles text-dark">
                                        <label>Roles</label>
                                        <div class="d-flex align-items-center">
                                            <div v-if="userRole == 'admin'">
                                                <input class="mr-1" type="checkbox" value="admin" v-model="user.roles" /> <span class="mr-1">Admin</span> <br />
                                            </div>
                                            <input class="mr-1" type="checkbox" value="author" v-model="user.roles" /> <span class="mr-1">Author</span> <br />
                                        </div>
                                    </div>
                                    <div class="d-flex mt-4">
                                        <div class="container-fluid d-flex flex-column">
                                            <label>Profile Intro Video</label>
                                            <video style="max-width: 100%" controls v-bind:src="user | s3url('video')" v-if="user.videoFileName" />
                                            <input type="file" @change="onFileChange($event.target, user, 'video')" style="background-color: white; color: black;" class="m-1" />
                                        </div>
                                        <div class="container-fluid d-flex flex-column">
                                            <label>Image</label>
                                            <img :src="user | s3url('profile')" />
                                            <input type="file" @change="onFileChange($event.target, user, 'profile')" style="background-color: white; color: black;" class="m-1" />
                                        </div>
                                    </div>
                                    <div class="container-fluid mt-5">
                                        <label>Bio</label>
                                        <textarea v-model="user.bio"></textarea>
                                    </div>

                                    <div class="container-fluid mt-4">
                                        <label>Assigned courses</label>
                                        <div class="table-responsive">
                                            <table class="table table-bordered text-center" style="background-color: white; max-height: 600px; overflow-y: scroll; ">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Site</th>
                                                        <th>Course name</th>
                                                        <th>Category</th>
                                                        <th>Assigned to</th>
                                                        <th>State</th>
                                                        <th>Score</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="course in filteredCourses">
                                                        <td>{{ course.id }}</td>
                                                        <td>{{ getSiteName(course.siteId) }}</td>
                                                        <td>{{ course.name }}</td>
                                                        <td>{{ course.category }}</td>
                                                        <td>
                                                            <input v-model="course.allocated" type="checkbox" />
                                                        </td>
                                                        <td>
                                                            <div v-if="course.allocated">
                                                                <span v-if="course.userCourse">
                                                                    Completed: {{ course.userCourse.completed }}<br />
                                                                    Passed: {{ course.userCourse.passed }}<br />
                                                                    Completed Date: {{ course.userCourse.completedDateTime }}
                                                                </span>
                                                            </div>
                                                            <div v-else>
                                                                Not assigned
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <input class="text-center" v-if="course.allocated && course.userCourse" v-model="course.userCourse.score" type="number" />
                                                            <span v-else>N/A</span>
                                                        </td>
                                                        <td>
                                                            <button v-if="course.userCourse && course.userCourse.passed && !course.isFacilitated" v-on:click="downloadCertificate(course)">Download Certificate</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-wrapper" v-show="showDelete" style="position: absolute; left:0; right: 0; top: 0; bottom: 0; background: rgba(32, 67, 107, 0.5)">
                <div class="card delete-modal w-50 mt-5 p-5 ml-auto mr-auto" style="margin-top: 350px!important;">
                    <div class="container-fluid text-center">
                        <h1>Confirm delete</h1>
                    </div>
                    <div class="container-fluid d-flex justify-content-center">
                        <button class="btn btn-add mr-3" v-on:click="deleteUser">Confirm</button>
                        <button class="btn btn-danger" v-on:click="toggleDeleteModal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>

    input[type=text] {
        border: 1px solid black !important;
    }

    .btn-template {
        padding: 10px 20px;
        color: white;
        border-radius: 12px;
    }

    .save-toast {
        position: fixed;
        top: 1em;
        right: 1em;
        background-color: #28a745;
        color: white;
        padding: 12px 20px;
        border-radius: 8px;
        font-weight: 600;
        z-index: 100000;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    .btn-delete-user {
        border: 1px solid red;
        background-color: red;
        margin-right: 20px;
    }

    .btn-save {
        border: 1px solid #42C1C4;
        background-color: #42C1C4;
    }

    .btn-delete-user:hover {
        background-color: white;
        color: red;
    }

    .btn-save:hover {
        color: #42C1C4;
        background-color: white;
    }


    .fixed-wrapper {
        position: fixed;
        right: 1em;
        bottom: 1em;
        padding-right: 30px;
        z-index: 1000;
    }

    .between {
        justify-content: space-between;
    }

    .end {
        justify-content: end;
    }
</style>
<script>
    import MixinsFileUploads from '../../mixinsFileUploads';
    import MixinsCertificates from '../../mixinsCertificates';

    export default {
        name: 'AdminUsersDetails',
        mixins: [MixinsFileUploads, MixinsCertificates],
        components: {
        },
        computed: {
            userId() {
                // We will see what `params` is shortly
                return this.$route.params.id
            },
            userRole() {
                var roles = this.$store.state.user.roles;
                return roles[0];
            },
            filteredCourses() {
                var filtered = [];

                if (this.userRole == "admin" && this.selectedSite) {
                    for (var i = 0; i < this.courses.length; i++) {
                        var currentCourse = this.courses[i];
                        if (currentCourse.siteId == this.selectedSite.id) {
                            filtered.push(currentCourse);
                        }
                    }
                }
                else {
                    filtered = this.courses;
                }

                return filtered;
            }
        },
        watch: {
            selectedSite: function (newVal, oldVal) {
                this.user.siteId = newVal.id;
            }
        },
        data: function () {
            return {
                user: null,
                courses: [],
                sites: [],
                selectedSite: null,
                showDelete: false,
                savedMessage: null
            }
        },
        methods: {
            siteHasProperty(property) {
                var result = false;
                var site = this.selectedSite;
                if (site && site.additionalProperties) {
                    result = site.additionalProperties.includes(property);
                }
                return result;
            },
            toggleDeleteModal() {
                this.showDelete = !this.showDelete;
            },
            async save() {
                await this.uploadFilesAsync(this.user, "profile");
                await this.uploadFilesAsync(this.user, "video");
                this.user.userCourses = this.courses.filter(x => x.allocated).map(function (x) { return { courseId: x.id, score: (x.userCourse ? parseFloat(x.userCourse.score) : null) } });
                var wasNew = this.user.id === 0;
                this.user = await this.web('/users', "Uploading user data", this.user);
                // web() throws on failure, so reaching here means the save succeeded
                this.savedMessage = wasNew ? "User created successfully" : "Saved successfully";
                setTimeout(() => { this.savedMessage = null; }, 3000);
            },
            getSiteName: function (siteId) {
                for (var i = 0; i < this.sites.length; i++) {
                    var site = this.sites[i];
                    if (site.id == siteId)
                        return site.name;
                }
                return "Unknown";
            },
            getSite: function(siteId) {
                for (var i = 0; i < this.sites.length; i++) {
                    var site = this.sites[i];
                    if (site.id == siteId)
                        return site;
                }
                return null;
            },
            async deleteUser() {
                this.showDelete = false;
                await this.web("/users/delete/" + this.user.id, "Deleting user");
                this.$router.push("/admin/users/");
            },
            async downloadCertificate(course) {
                console.log("Certificate view");

                debugger;
                //get certificate information
                var result = await this.web("/courses/certificate/usercourse/", "Loading certificate details", { courseId: course.id, userId: this.user.id });

                debugger;
                this.course = result.course;
                this.courseDetails = result.courseDetails;
                this.user = result.user;

                console.log("downloadCertificate");
                var pdfBytes = await this.generateCertificate(this.course, this.courseDetails, this.user);

                console.log("Downloading PDF");
                var bytes = new Uint8Array(pdfBytes); // pass your byte response to this constructor
                var blob = new Blob([bytes], { type: "application/pdf" });// change resultByte to bytes

                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = "Certificate.pdf";
                link.click();
            }
        },
        async mounted() {
            this.user = await this.web('/users/' + this.userId, "Loading user");
            if (this.userRole == 'admin') {
                this.sites = await this.web("/sites", "Loading sites");
                for (var i = 0; i < this.sites.length; i++) {
                    var currentSite = this.sites[i];
                    if (this.user.siteId == currentSite.id) {
                        this.selectedSite = currentSite;
                    }
                }
                var courses = await this.web("/courses?filters=admin&filters=all", "Loading courses");
                if (this.user.id === 0 && this.selectedSite === null) {
                    this.selectedSite = this.sites[0];
                }
            }
            else {
                var courses = await this.web("/courses?filters=all", "Loading courses");
                this.selectedSite = this.user.siteId;
            }

            for (var i = 0; i < courses.length; i++) {
                var course = courses[i];
                var userCourse = this.user.userCourses.filter(x => x.courseId == course.id);
                if (userCourse && userCourse.length > 0) {
                    course.allocated = true;
                    course.userCourse = userCourse[0];
                }
                else {
                    course.allocated = false;
                    course.userCourse = null;
                }
            }
            this.courses = courses;
            var crumbs = {};
            crumbs["/admin/users"] = "Users";
            crumbs["/admin/users/" + this.userId] = (this.userId == 0 ? "New user" : "Edit user details");
            this.$store.commit("breadCrumbs", crumbs);



        }
    }
</script>
